// Lib
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { getNotificationNewBoardTitles } from './utils/notificationEntryElementChangeUtils';

// Components
import BoardTitleSummary from './BoardTitleSummary';

const mapStateToProps = createSelector(
    (state, ownProps) => ownProps.notification,
    (notification) => ({
        boardTitles: getNotificationNewBoardTitles({ notification }),
    }),
);

export default connect(mapStateToProps)(BoardTitleSummary);
